
import mixins from "vue-typed-mixins";
import Common from "@/mixins/Common";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { PatientPortalRxContainer } from "@/interfaces/PatientPortalRxContainer";
import { PatientPortalRx } from "@/interfaces/PatientPortalRx";
import { PatientPortalViewModel } from "@/interfaces/PatientPortalViewModel";
import swal from "sweetalert";
import store from "@/store";
import router from "@/router";
import { AjaxReturnViewModel } from "@/interfaces/AjaxReturnViewModel";
import { PatientPortalShoppingCartItem } from "@/interfaces/PatientPortalShoppingCartItem";
import { VisitType } from "@/interfaces/VisitType";
import { BRow, BCol, BContainer, BJumbotron, BIcon, BFormSelect, BFormSelectOption, BModal } from "bootstrap-vue";
import SupportOrderHistoryVueComponent from "@/components/SupportOrderHistoryVueComponent.vue";
import RxHistoryVueComponent from "@/components/RxHistoryVueComponent.vue";

export interface IBookingWidget {
  [x: string]: any;
  initialize: (arg0: any, arg1: any) => void;
}

export interface IGReminders {
  BookingWidget: IBookingWidget;
}

const GReminders: IGReminders = (window as any).GReminders;

export default mixins(Common).extend({
  mixins: [Common],
  name: "StatusView",
  props: {
    t: { type: String, default: null },
  },
  data() {
    return {
      vm: null as PatientPortalViewModel | null,
      cQ: null as PatientPortalRxContainer | null,
      orderVM: null as {
        patientUserID: number;
        patientAffiliateID: number;
        questionnaireTypeID: number;
        rxID: number;
      } | null,
      instantVisitSrc: null as string | null,
      instantVisitQuestionnaireTypeID: null as number | null,
      isCollapsed: {} as Record<number, boolean>,
      waitForVisitLink: false as boolean,
      waitForVisitLinkRetry: 0 as number,
    };
  },
  async mounted() {
    const result = await this.GetPatientPortal();
    this.vm = result.data;
    this.sortRxs();
    this.setMostRecentRx();
  },
  computed: {
    ...mapGetters({
      Content: "getContent",
      Lang: "getLang",
    }),
    renewRxButtonLabel(): string {
      const content = this.Content;
      const lang = this.Lang;

      return content?.lang?.[lang]?.RenewRXButton ?? content?.RenewRXButton ?? "Renew Rx";
    },
    PatientPortalButtonText(): string {
      if (this.Content && !this.Content.lang) {
        return this.Content && this.Content.PatientPortalButtonText ? this.Content.PatientPortalButtonText : "Patient Portal";
      }
      if (this.Content && this.Content.lang) {
        return this.Content.lang[this.Lang].PatientPortalButtonText;
      } else return "Patient Portal";
    },
    PatientPortalButtonURL(): string {
      if (this.Content && !this.Content.lang) {
        return this.Content && this.Content.PatientPortalButtonURL ? this.Content.PatientPortalButtonURL : "#";
      }
      if (this.Content && this.Content.lang) {
        return this.Content.lang[this.Lang].PatientPortalButtonURL;
      } else return "#";
    },
  },
  methods: {
    ...mapActions(["GetPatientPortal"]),
    sortRxs() {
      this.vm?.rxs.forEach((x: PatientPortalRxContainer) => {
        x.rxs.sort((a, b) => this.getContentJSONOrder(a) - this.getContentJSONOrder(b));
      });
      this.vm?.rxs.sort((a: PatientPortalRxContainer, b: PatientPortalRxContainer) => {
        return b.questionnaireID - a.questionnaireID;
      });
      this.vm?.renewalRxs.forEach((x: PatientPortalRxContainer) => {
        x.rxs.sort((a, b) => this.getContentJSONOrder(a) - this.getContentJSONOrder(b));
      });
      this.vm?.renewalRxs.sort((a: PatientPortalRxContainer, b: PatientPortalRxContainer) => {
        return b.questionnaireID - a.questionnaireID;
      });
    },
    setMostRecentRx() {
      var renewalQ = this.vm?.renewalRxs.find((item: PatientPortalRxContainer) => item.questionnaireTypeID == parseInt(this.t));
      var q = this.vm?.rxs.find((item: PatientPortalRxContainer) => item.questionnaireTypeID == parseInt(this.t));
      if (renewalQ && q && renewalQ.questionnaireID > q.questionnaireID) {
        this.cQ = renewalQ;
      } else if (q) {
        this.cQ = q;
      }
    },
    ...mapMutations({
      setCurrentQuestType: "setCurrentQuestType",
      setCurrentRxID: "setCurrentRxID",
      setCurrentRefillNum: "setCurrentRefillNum",
      SetLoading: "setLoading",
      setShowMainMenu: "setShowMainMenu",
      setsAutoSavePatientProfile: "setAutoSavePatientProfile",
      setIsVerifiedQuickLink: "setIsVerifiedQuickLink",
      setMarketplaceEstimates: "setMarketplaceEstimates",
      setShowSubscriptionPaymentFlow: "setShowSubscriptionPaymentFlow",
      setShowPharmacyCart: "setShowPharmacyCart",
      setShowSubscriptionManagement: "setShowSubscriptionManagement",
    }),
    getShowDirections(rx: PatientPortalRx): boolean | null {
      if (rx.apRxContentJSON) {
        return JSON.parse(rx.apRxContentJSON).ShowDirections;
      }
      return null;
    },
    getRxTitleOverride(rx: PatientPortalRx, Lang?: string | null): string | null {
      if (!rx.apRxContentJSON) return null;

      try {
        const content = JSON.parse(rx.apRxContentJSON);

        if (Lang && content.lang && content.lang[Lang] && content.lang[Lang].RxTitleOverride) {
          return content.lang[Lang].RxTitleOverride;
        }

        return content.RxTitleOverride || null;
      } catch (e) {
        console.error("Invalid JSON in getRxTitleOverride:", e);
        return null;
      }
    },
    getGroupRxFooter(rx: PatientPortalRx): string | null {
      if (rx.apRxContentJSON) {
        return JSON.parse(rx.apRxContentJSON).GroupRxFooter;
      }
      return null;
    },
    getContentJSONOrder(rx: PatientPortalRx): number {
      if (rx.apRxContentJSON) {
        return isNaN(JSON.parse(rx.apRxContentJSON).PatientPortalOrder) ? 9999 : parseInt(JSON.parse(rx.apRxContentJSON).PatientPortalOrder);
      }
      return 9999;
    },
    FinishVisit(t: number) {
      this.setCurrentQuestType(t);
      window.location.href = "/questionnaire";
    },
    PayQuest(t: number) {
      this.setCurrentQuestType(t);
      router.push("/payment");
    },
    Pay(r: PatientPortalRxContainer) {
      if (!r.questionnaireID && r.rxID && r.rxID > 0) {
        this.setCurrentRxID(r.rxID);
        router.push("/rx/payment");
        return;
      }
      this.PayQuest(r.questionnaireTypeID);
    },
    SubChargePay(r: PatientPortalRxContainer) {
      this.setCurrentQuestType(r.questionnaireTypeID);
      router.push("/subchargepayment");
    },
    Refill(rxc: PatientPortalRxContainer) {
      if (rxc.useSamCart) {
        window.location.href = rxc.externalCartUrl;
      } else {
        if (!rxc.questionnaireID && rxc.rxID && rxc.rxID > 0) {
          this.setCurrentRxID(rxc.rxID);
          this.setCurrentRefillNum(rxc.numberOfRefillsRemaining);
          router.push("/rx/refill");
          return;
        }
        this.setCurrentQuestType(rxc.questionnaireTypeID);
        this.setCurrentRefillNum(rxc.numberOfRefillsRemaining);
        router.push(`/refill`);
      }
    },
    Modify(r: PatientPortalRxContainer) {
      this.setCurrentQuestType(r.questionnaireTypeID);
      this.setCurrentRefillNum(r.numberOfRefillsRemaining);
      router.push(`/modify`);
    },
    UpdatePhotos(t: number) {
      this.setCurrentQuestType(t);
      router.push("/photos");
    },
    async go_external(questionnaireTypeID: number) {
      if (this.waitForVisitLinkRetry >= 60) {
        swal({
          title: "Error",
          text: "Failed to retrieve the visit link after multiple attempts. Please try again later.",
          icon: "error",
        });
        this.waitForVisitLink = false;
        this.waitForVisitLinkRetry = 0;
        return;
      }
      this.waitForVisitLinkRetry += 1;
      this.waitForVisitLink = true;
      var tResult: AjaxReturnViewModel<string> = await store.dispatch("GetTelegraVisitURL", { questionnaireTypeID: questionnaireTypeID });
      console.log("Telegra visit URL result:", tResult);
      if (!tResult || !tResult.success || !tResult.data) {
        window.setTimeout(() => {
          this.go_external(questionnaireTypeID);
        }, 5000);
        return;
      }
      //window.open(tResult.data, "_blank");
      document.location.href = tResult.data;
      this.waitForVisitLink = false;
    },
    async Renew(rxc: PatientPortalRxContainer) {
      if (rxc.useSamCart) {
        window.location.href = rxc.externalCartUrl;
      } else {
        this.SetLoading(true);
        var tResult: AjaxReturnViewModel<boolean> = await store.dispatch("Renew", rxc.questionnaireTypeID);
        this.SetLoading(false);
        if (!tResult || !tResult.success || !tResult.data) {
          this.SetLoading(false);
          swal("Error", "There was an error renewing your Rx! Please refresh and try again.", "error");
          return;
        }
        this.setCurrentQuestType(rxc.questionnaireTypeID);
        if (this.$gtm && this.$gtm.enabled() && (this.Content.GTMConfig || this.Content.lang[this.Lang].GTMConfig) && !this.Content.GTMToggleOff) {
          window.dataLayer?.push({
            event: "renewalClicked",
          });
        }
        window.location.href = "/questionnaire";
      }
    },
    Reschedule(rx: PatientPortalRxContainer) {
      GReminders.BookingWidget.initialize(
        //create an event type and put the link below: https://app.greminders.com/event-types
        rx.calendlyUrl,
        {
          fields: {
            first_name: this.vm?.patient.firstName, //you can prepopulate the fields here if you already have this information
            last_name: this.vm?.patient.lastName,
            email: this.vm?.email,
            c_customdata: JSON.stringify({ QuestionnaireID: rx.questionnaireID, AffiliateID: this.vm?.patient.affiliateID, Reschedule: true }), //populate custom questions/fields as well: https://app.greminders.com/admin/custom-questions
            auto_submit: true, //to auto submit the form set this true, default is false, note the form must pass validation
          },
        }
      );
      GReminders.BookingWidget.onSuccess(async (event_id: string | number) => {
        //we automatically close the widget on successful booking, you can continue your flow here
        await store.dispatch("SaveReschedule", event_id);
        GReminders.BookingWidget.close();
        swal("Your visit has been rescheduled!", "The new visit may take a few minutes to show up in the dashboard. You may refresh the screen to check for the updated time.", "success");
      });
      GReminders.BookingWidget.onError((message: string | number) => {
        //if we encounter a booking error you can trigger a different error or retry
        GReminders.BookingWidget.close();
        swal("Error Scheduling Appointment", "Please try scheduling again.", "error");
      });
      GReminders.BookingWidget.open();
    },
    StartVisit(cl: string, visitType: VisitType, qt: number | null) {
      if (visitType == VisitType.Instant) {
        this.instantVisitSrc = cl;
        this.instantVisitQuestionnaireTypeID = qt;
        this.$bvModal.show("modal-instant-visit");
      } else {
        window.open(cl, "_blank");
      }
    },
    ShowRxHistory() {
      this.$bvModal.show("modal-rx-history");
    },
    ShowPatientProfile() {
      this.$bvModal.show("modal-pp");
    },
    ShowLabResults() {
      this.$bvModal.show("modal-lab");
    },
    ShowRefillConfirmation() {
      this.$bvModal.show("modal-refill");
    },
    CloseRefillConfirmation() {
      this.$bvModal.hide("modal-refill");
    },
    ShowWeightTrackerModal() {
      this.$bvModal.show("modal-weight");
    },
    ShowMedTrackerModal() {
      this.$bvModal.show("modal-med");
    },
    async ToggleSubscription(rx: PatientPortalRxContainer) {
      if (rx.isSubscription) {
        swal({
          text: "You can turn Auto-Refill back on during your next refill if desired.",
          title: "Are you sure you want to turn off Auto-Refill?",
          icon: "warning",
          buttons: ["No", "Yes"],
        }).then(async (result) => {
          if (result) {
            var tResult: AjaxReturnViewModel<boolean> = await store.dispatch("ToggleSubscription", rx.questionnaireTypeID);
            if (!tResult || !tResult.success || !tResult.data) {
              this.SetLoading(false);
              swal("Error", "There was an error turning Auto-Refill off! Please refresh and try again.", "error");
              return;
            }
            this.SetLoading(false);
            this.Refresh();
            return;
          }
        });
      } else {
        swal({
          text: "You can turn Auto-Refill back on during your next refill if desired.",
          title: "Auto-Refill",
          icon: "info",
        });
        rx.isSubscription = false;
        let rxs = this.vm?.rxs.filter((r) => r.questionnaireID != rx.questionnaireID && r.rxID != rx.rxID);
        rxs?.push(rx);
        this.vm.rxs = rxs as PatientPortalRxContainer[];
      }
    },
    Track(rx: PatientPortalRx | PatientPortalShoppingCartItem) {
      swal("Warning", "You are about to leave our site and navigate to a shipping carrier site.", "warning").then(() => {
        window.open(rx.trackingString.replace("{0}", rx.trackingNumber), "_blank");
      });
    },
    ShowOrderHistory(questionnaireTypeID: number, rxID: number) {
      this.orderVM = {
        patientUserID: this.vm?.patient.userID ? this.vm?.patient.userID : 0,
        patientAffiliateID: this.vm?.patient.affiliateID ? this.vm?.patient.affiliateID : 0,
        questionnaireTypeID: questionnaireTypeID,
        rxID: rxID,
      };
      this.$bvModal.show("modal-order");
    },
    nameIconToggle(ID: number, isAfterFirstItem: boolean) {
      if (this.isCollapsed[ID] === undefined) {
        this.$set(this.isCollapsed, ID, isAfterFirstItem);
      }
      this.$set(this.isCollapsed, ID, !this.isCollapsed[ID]);
    },
    openUnfinishedModal() {
      const isIncompletes = this.vm?.rxs.filter((item) => item.isIncomplete);
      const isIncomplete = isIncompletes && isIncompletes.length > 0 ? true : false;

      if (isIncomplete && this.Content.IncompleteModalContent) {
        setTimeout(() => {
          this.$bvModal.show("unfinshed-modal");

          setTimeout(() => {
            this.modalClickListener();
          }, 1000);
        }, 1000);
      }
    },
    openNeedScheduleModal() {
      const isAwaitingVisitScheduling = this.vm?.rxs.filter((item) => item.isAwaitingVisitScheduling);
      const needSchedule = isAwaitingVisitScheduling && isAwaitingVisitScheduling.length > 0 ? true : false;

      if (needSchedule && this.Content.NeedScheduleModalContent) {
        setTimeout(() => {
          this.$bvModal.show("need-schedule-modal");

          setTimeout(() => {
            this.modalClickListener();
          }, 1000);
        }, 1000);
      }
    },

    openNeedPhotoModal() {
      const isPhotoRejected = this.vm?.rxs.filter((item) => item.isPhotoRejected);
      const needsPhotos = isPhotoRejected && isPhotoRejected.length > 0 ? true : false;
      const patientStartDateDisplay = this.vm?.rxs.filter((item) => item.patientStartDateDisplay);
      const patientDateDisplay = patientStartDateDisplay && patientStartDateDisplay.length > 0 ? true : false;

      if (needsPhotos && (!patientDateDisplay || this.Content.NeedPhotosModalContentForceShow) && this.Content.NeedPhotosModalContent) {
        setTimeout(() => {
          this.$bvModal.show("need-photo-modal");

          setTimeout(() => {
            this.modalClickListener();
          }, 1000);
        }, 1000);
      }
    },
    openWelcomeDashModal() {
      if (this.Content.WelcomeDashModalContent) {
        setTimeout(() => {
          this.$bvModal.show("welcome-dash-modal");

          setTimeout(() => {
            this.modalClickListener();
          }, 1000);
        }, this.Content.WelcomeDashModalTimer);
      }
    },
    modalClickListener() {
      const finishProgramButton = document.getElementById("finish-program");
      const closeFinishModalButton = document.getElementById("close-modal");
      const closePhotoModalButton = document.getElementById("close-photo-modal");
      const closeWelcomeModalButton = document.getElementById("close-welcome-modal");
      const closeScheduleModalButton = document.getElementById("close-schedule-modal");

      if (finishProgramButton) {
        finishProgramButton.addEventListener("click", () => {
          this.FinishVisit(13);
        });
      }
      if (closeFinishModalButton) {
        closeFinishModalButton.addEventListener("click", () => {
          this.$bvModal.hide("unfinshed-modal");
        });
      }
      if (closePhotoModalButton) {
        closePhotoModalButton.addEventListener("click", () => {
          this.$bvModal.hide("need-photo-modal");
        });
      }
      if (closeWelcomeModalButton) {
        closeWelcomeModalButton.addEventListener("click", () => {
          this.$bvModal.hide("welcome-dash-modal");
        });
      }
      if (closeScheduleModalButton) {
        closeScheduleModalButton.addEventListener("click", () => {
          this.$bvModal.hide("need-schedule-modal");
        });
      }
    },
  },
  components: {
    BRow,
    BCol,
    BContainer,
    BJumbotron,
    BIcon,
    SupportOrderHistoryVueComponent,
    BFormSelect,
    BFormSelectOption,
    BModal,
    RxHistoryVueComponent,
  },
});
